<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fbTXLn/tc-custom/9781528948227.jpg?1709061882627" alt="This image is the cover for the book The Film"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Film
      </h1>
      <p class="bookDescription body article font2">
        <p>The Film â€“ fact-based novel in which facts and fictions are mingled â€“ is about a young man who finds himself being interviewed as an actor. He feels that he is someone else, not an actor. However, there are things which prove that he is an actor: he knows everything about film. And there are things which confirm that he is someone else. He is not sure who and what he is. He is not sure where he is. He is not sure what is real and what is unreal. He doubts not only his own identity, but the identities of the others in the room. He cannot believe in what he experiences. He cannot believe in what he thinks and feels. He does not know on whom and on what he should rely. The Film is a novel which gives the reader not only intellectual pleasure, but things for meditating.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kè Su Thar
      </h2>
      
      <p class="authorDescription body article">Kè Su Thar was born in 1965, in Aung Lan, a small town of Burma (Myanmar). His parents were so poor that they could not afford to school him. Hence, his formal education ended early in his childhood, in primary level. However, he never gave up learning. He taught and groomed himself. He has written some short stories and three novels—Karzu, Forgotten Biography and His Day—all in Burmese. His short stories have appeared in some magazines. This is his first novel written in English. Now he lives in Yangon with his elder sister’s family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3071b778